import { signInWithRedirect } from 'firebase/auth'
import {
  GoogleAuthProvider,
  deleteUser,
  signInAnonymously as firebaseSignInAnonymously,
  signOut as firebaseSignOut,
  getAuth,
} from 'firebase/auth'

class AuthenticationService {
  signInWithGoogle() {
    signInWithRedirect(getAuth(), new GoogleAuthProvider())
  }

  signInAnonymously() {
    return firebaseSignInAnonymously(getAuth())
  }

  signOut() {
    return firebaseSignOut(getAuth())
  }

  deleteAccount() {
    const user = getAuth().currentUser
    if (!user) return
    deleteUser(user)
  }

  refreshIdToken() {
    const user = getAuth().currentUser
    if (!user) return

    return user.getIdToken(true)
  }

  getAccessToken() {
    const user = getAuth().currentUser
    if (!user) return

    return user.getIdToken()
  }
}

const authenticationService = new AuthenticationService()

export default authenticationService
